import { ConfigService, configServiceFactory } from "./config.service";
import { RappService } from "./rapp-services.service";

export const services: any[] = [
    { provide: ConfigService, useFactory: configServiceFactory },
    RappService
];

export * from './config.service';